module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Remigen_AG-bf1d27693a28760a16456b6f78643d36.svg";